import { render, staticRenderFns } from "./password.vue?vue&type=template&id=643c024c&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports